// /CoreWrapper/cores/coreColor.js
/* eslint-disable react/prop-types */
import React from 'react'

export function coreColor(BaseComponent) {
	const WithColor = ({
		color,
		colorHover,
		className = '',
		style = {},
		...rest
	}) => {
		// No border config → no feature
		if (!color && !colorHover) {
			return (
				<BaseComponent className={className} style={style} {...rest} />
			)
		}

		const classes = ['wbk-color', className].filter(Boolean).join(' ')

		const mergedStyle = {
			'--wbk-color': color,
			'--wbk-color-hover': colorHover || color,
			...style
		}

		return (
			<BaseComponent className={classes} style={mergedStyle} {...rest} />
		)
	}

	return WithColor
}
